import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
} from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { SupportUserListService } from "../../../../core/services/support-user-list.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { DropdownModule } from "primeng/dropdown";
import { CommonModule } from "@angular/common";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { Popover } from "primeng/popover";
import { ButtonModule } from "primeng/button";
import { IconFieldModule } from "primeng/iconfield";
import { InputIconModule } from "primeng/inputicon";
import { InputTextModule } from "primeng/inputtext";
import { MenuModule } from "primeng/menu";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ListboxClickEvent, ListboxModule } from "primeng/listbox";
import { AddUserList } from "../../../../core/models/profile/addUserList";

@UntilDestroy()
@Component({
  selector: "jni-support-user-list",
  templateUrl: "./support-user-list.component.html",
  standalone: true,
  imports: [
    DropdownModule,
    CommonModule,
    Popover,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    MenuModule,
    ListboxModule,
  ],
  styleUrls: ["./support-user-list.component.scss"],
})
export class SupportUserListComponent implements OnInit, OnChanges {
  @Input() userAddTableData: UsersList[] = [];
  @Input() datastatus = "";
  afterFilterSearch: UsersList[] = [];
  userList?: AddUserList;
  @Input() userId = "";
  supportIds: number[] = [];
  userRoleId = 0;
  currentUserId = 0;
  addAndRemoveStatus = false;

  @Output() userSupportMapDataEvent = new EventEmitter<void>();
  @Output() smallLoaderAddTableEvent = new EventEmitter<boolean>();
  @Output() deleteUserSupportEvent = new EventEmitter<string>();
  @Output() deleteButtonEvent = new EventEmitter<boolean>();
  @Output() supportGridRightsEvent = new EventEmitter();
  @Output() LoginUserEvent = new EventEmitter();

  constructor(
    private _route: ActivatedRoute,
    private _supportUserListService: SupportUserListService,
    private _toastr: JniToastrService,
    private _loginService: UserManagementService,
    private _profileloginService: ProfileFormService
  ) {
    this._route.params.subscribe((params: Params) => {
      this.userId = params["id"];
    });
    if (this.userId) {
      this.getLoginUser();
    }
  }

  getLoginUser() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        if (res.data) {
          this.userRoleId = res.data.userRoleId;
          this.getCurrentUserProfile(parseInt(this.userId));
          this.LoginUserEvent.emit(this.userRoleId);
          this.addAndRemoveStatus = false;
        }
      });
  }

  getCurrentUserProfile(userId: number) {
    this._profileloginService
      .getUsersById(userId)
      .subscribe((res: GenericResponseDto<GetUserDto>) => {
        if (res.data) {
          this.currentUserId = res.data.userRoleId;
          this.getUserRoleValidation();
          const supportGrid = {
            userRoleId: this.userRoleId,
            currentId: this.currentUserId,
          };

          this.supportGridRightsEvent.emit(supportGrid);
        }
      });
  }

  ngOnInit(): void {
    this.afterFilterSearch = this.userAddTableData;
    this.supportIds = [];
    this.userList = {
      userId: 0,
      supportsUserIds: [],
    };
  }

  onClick(event: ListboxClickEvent) {
    const option = event.option as UsersList;
    if (option) {
      if (!this.supportIds.find(x => x == option.id)) {
        this.supportIds.push(option.id);
      } else {
        const index = this.supportIds.indexOf(option.id);
        if (index > -1) {
          this.supportIds.splice(index, 1);
        }
      }
    }
  }

  importUsersHandler(myDropDown: Popover) {
    this.smallLoaderAddTableEvent.emit(true);

    this.userList = {
      userId: parseInt(this.userId),
      supportsUserIds: this.supportIds,
    };

    if (this.datastatus == "Who I Support") {
      this.updateUserForWIS(this.userList, myDropDown);
    } else if (this.datastatus == "Who Supports Me") {
      this.updateUserForWSM(this.userList, myDropDown);
    }
  }

  deleteElementInAddTable(id: number) {
    this.afterFilterSearch.splice(
      this.afterFilterSearch.findIndex(function (i) {
        return i.id === id;
      }),
      1
    );
  }

  updateUserForWIS(userList: AddUserList, myDropDown: Popover) {
    this._supportUserListService
      .addUserFromTableWIS(userList)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.userSupportMapDataEvent.emit();
          this.smallLoaderAddTableEvent.emit(false);
          this._toastr.success("Success", "User add successfully!");
          this.supportIds = [];
          for (const item of userList.supportsUserIds) {
            this.deleteElementInAddTable(item);
          }
          myDropDown.hide();
        },
        error: () => {
          this.userSupportMapDataEvent.emit();
          this.smallLoaderAddTableEvent.emit(false);
          this._toastr.error("Error", "User not found");
          myDropDown.hide();
        },
      });
  }

  updateUserForWSM(userList: AddUserList, myDropDown: Popover) {
    this._supportUserListService
      .addUserFromTableWSM(userList)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.userSupportMapDataEvent.emit();
          this.smallLoaderAddTableEvent.emit(false);
          this._toastr.success("Success", "User add successfully!");
          this.supportIds = [];
          for (const item of userList.supportsUserIds) {
            this.deleteElementInAddTable(item);
          }
          myDropDown.hide();
        },
        error: () => {
          this.userSupportMapDataEvent.emit();
          this.smallLoaderAddTableEvent.emit(false);
          this._toastr.error("Error", "User not found");
          myDropDown.hide();
        },
      });
  }

  onNameFilter(name: KeyboardEvent) {
    const input = name.target as HTMLInputElement;
    const searchValue = input.value;
    if (searchValue != "") {
      const obj = this.userAddTableData.filter(x =>
        x.name.toLowerCase().includes(searchValue.toLowerCase())
      );
      this.userAddTableData = obj;
    } else {
      this.userAddTableData = this.afterFilterSearch;
    }
  }

  deleteUserSupport() {
    this.deleteUserSupportEvent.emit(this.datastatus);
  }

  getUserRoleValidation() {
    this.smallLoaderAddTableEvent.emit(true);
    if (
      (this.userRoleId === UserRole.Manager ||
        this.userRoleId === UserRole.Admin) &&
      this.currentUserId === UserRole.Sales
    ) {
      this.addAndRemoveStatus = true;
      this.deleteButtonEvent.emit(true);
      this.smallLoaderAddTableEvent.emit(false);
    } else {
      this.deleteButtonEvent.emit(false);
      this.addAndRemoveStatus = false;
      this.smallLoaderAddTableEvent.emit(false);
    }
  }

  SupportUserList(whoSupportMeAddTableData: UsersList[]) {
    this.afterFilterSearch = whoSupportMeAddTableData;
  }

  ngOnChanges() {
    if (this.userId) {
      this.getLoginUser();
    }
  }
}
